import ApiBase from './api-base'
import {ACTIVE_BASE_REST} from './constants'

export default class Log extends ApiBase {
    constructor(store) {
        const path = `${ACTIVE_BASE_REST}/record`
        super(store, path)
    }

    report(type, filter, showProgress) {
        return this._request({
            action: `${type}/report`,
            method: 'GET',
            params: filter,
            showProgress
        })
    }

    export(type, params, showProgress) {
        return this._request({
            action: `${type}/export`,
            method: 'GET',
            params,
            showProgress
        })
    }

    detail(type, id, showProgress) {
        return this._request({
            action: `${type}/${id}/detail`,
            method: 'GET',
            showProgress
        })
    }
}